<hlm-form-field class="w-full">
  <label hlmLabel [for]="control">
    {{ label }}

    @if (required()) {
      <span class="text-primary">*</span>
    }
  </label>

  <div class="relative block">
    @if (prefixIcon) {
      <lucide-icon [size]="iconSize" [name]="prefixIcon" class="absolute left-1.5 top-1/2 block -translate-y-1/2 text-gray-500" />
    }

    <input
      hlmInput
      [id]="control"
      [mask]="_computeMask()"
      [formControlName]="control"
      [autocomplete]="autocomplete"
      [disabled]="disabled"
      [readonly]="readOnly"
      [attr.inputMode]="inputMode"
      [minlength]="formControl.errors?.['minlength']?.requiredLength ?? 0"
      [maxlength]="formControl.errors?.['maxlength']?.requiredLength ?? 250"
      [ngClass]="{ 'pl-9': prefixIcon, 'pr-9': suffixIcon }"
      [type]="type"
      [placeholder]="placeholder"
      (input)="onChange.emit($event)" />

    @if (suffixIcon) {
      <lucide-icon
        [size]="iconSize"
        [name]="suffixIcon"
        class="absolute right-1.5 top-1/2 block -translate-y-1/2 cursor-pointer text-gray-500"
        (click)="suffixClick.emit()" />
    }
  </div>

  <!-- <hlm-error [control]="control" class="text-xs"/> -->
  @if (displayErrors()) {
    @for (err of formControl.errors | keyvalue; track err) {
      <small class="text-xs font-normal text-error-500">
        @if (err.key === 'minlength') {
          Minimum length is {{ err.value.requiredLength }} characters
        } @else if (err.key === 'maxlength') {
          Maximum length is {{ err.value.requiredLength }} characters
        } @else {
          {{ errorMessages[err.key] }}
        }
      </small>
    }
  }

  @if (hint) {
    <hlm-hint>{{ hint }}</hlm-hint>
  }
</hlm-form-field>
